import { HugeiconsIcon } from "@hugeicons/react";
import { GiftIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";
import useTranslations from "../../i18n/useTranslations";
import type { RewardsButtonStatus } from "../../types";

type Props = {
  progress: number;
  status: RewardsButtonStatus;
  expanded?: boolean;
  onClick?: () => void;
};

const RewardsButton: FC<Props> = ({
  progress,
  status,
  expanded = false,
  onClick,
}) => {
  const t = useTranslations();

  return (
    <span
      data-slot="rewards-button"
      data-status={status}
      className="relative inline-flex"
    >
      <Button
        variant="outline"
        size="icon-xl"
        aria-label={t("reward_center.button.aria_label")}
        aria-expanded={expanded}
        onClick={onClick}
        className="size-10 rounded-xl border-border bg-accent text-muted-foreground hover:text-foreground aria-expanded:text-foreground md:size-10"
      >
        <HugeiconsIcon
          icon={GiftIcon}
          className="size-5 in-data-[status=warning]:text-(--rc-warning)"
        />
      </Button>
      <svg
        viewBox="0 0 40 40"
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 size-10 fill-none"
      >
        <rect
          x="1.25"
          y="1.25"
          width="37.5"
          height="37.5"
          rx="10.75"
          strokeWidth="2.5"
          className="stroke-foreground/8"
        />
        <rect
          x="1.25"
          y="1.25"
          width="37.5"
          height="37.5"
          rx="10.75"
          strokeWidth="2.5"
          strokeLinecap="round"
          pathLength={100}
          strokeDasharray="100"
          strokeDashoffset={100 - progress}
          className="stroke-primary transition-[stroke-dashoffset] duration-500"
        />
      </svg>
      <span className="pointer-events-none absolute -top-0.75 -right-0.75 hidden size-2.5 rounded-full shadow-[0_0_0_2.5px_var(--background)] in-data-[status=claimable]:block in-data-[status=claimable]:bg-(--rc-success) in-data-[status=warning]:block in-data-[status=warning]:bg-(--rc-warning)" />
    </span>
  );
};

export default RewardsButton;
